import axios from 'axios';
import {
  LOGIN_API,
  GET_USER_PROFILE_API,
  API_KEY_ACCOUNTS,
  API_KEY_BUILDERS,
  USER_ACCEL_SESSIONS_API,
  UPDATE_USER_PROFILE_API,
  GET_USER_BUSINESSES_API,
  USER_BUSINESSES_API,
  AUTHORISE_BUILDER_ENDPOINT_URL,
  ACTIVITY_LOG_API,
} from '../constants';

export function* loginApi(username, password) {
  const response = yield axios({
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': API_KEY_ACCOUNTS,
    },
    data: {
      username,
      password,
    },
    url: `${LOGIN_API}/my-build`,
    validateStatus(status) {
      return status >= 200 && status <= 403; // default
    },
  });
  // console.log({ response });
  return response;
}

export function* getUser(accessToken) {
  // get the user profile
  const response = yield axios({
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
      'x-api-key': API_KEY_ACCOUNTS,
    },
    url: GET_USER_PROFILE_API,
    validateStatus(status) {
      return status >= 200 && status <= 403; // default
    },
  });
  return response;
}
export function* createActivity(accessToken, activityName) {
  // get the user profile
  const response = yield axios({
    method: 'POST',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
      'x-api-key': API_KEY_BUILDERS,
    },
    data: {
      activityName,
    },
    url: ACTIVITY_LOG_API,
    validateStatus(status) {
      return status >= 200 && status <= 403; // default
    },
  });
  // console.log({ response }, 'create actiivty');
  return response;
}

export function* getUserBusinesses(accessToken) {
  const response = yield axios({
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
      'x-api-key': API_KEY_BUILDERS,
    },
    url: GET_USER_BUSINESSES_API,
  });
  return response;
}

export function* updateUserBusiness(
  accessToken,
  businessNumber,
  businessDetails,
) {
  const response = yield axios({
    method: 'PUT',
    data: businessDetails,
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
      'x-api-key': API_KEY_BUILDERS,
    },
    url: `${USER_BUSINESSES_API}/${businessNumber}`,
  });
  return response;
}

export function* createAccelSession(accessToken) {
  const response = yield axios({
    method: 'POST',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
      'x-api-key': API_KEY_BUILDERS,
    },
    url: USER_ACCEL_SESSIONS_API,
    validateStatus(status) {
      return status >= 200 && status <= 403; // default
    },
  });
  return response;
}

export function* updateUserProfile(accessToken, userAttributes) {
  // console.log('userAttributes');
  // console.log(userAttributes);
  const response = yield axios({
    method: 'post',
    data: {
      attributes: userAttributes,
    },
    url: UPDATE_USER_PROFILE_API,
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
      'x-api-key': API_KEY_ACCOUNTS,
    },
  });
  return response;
}

export function* confirmApproveBuilder(confirmBuilderToken, isDeactivate) {
  const response = yield axios({
    method: 'post',
    data: {
      token: confirmBuilderToken,
      isDeactivate,
    },
    url: AUTHORISE_BUILDER_ENDPOINT_URL,
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': API_KEY_BUILDERS,
    },
  });
  return response;
}
